<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0 px-0">
          <b-tabs class="gridtabs">
            <b-tab active>
              <template #title>
                <i :class="options.icon_header" class="text-primary mr-1"></i>
                {{ item.yourref }}
                <span class="text-warning"
                  >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
                >
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      :label="
                        $helpers.requiredlabel(
                          requirement,
                          'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                        )
                      "
                      :class="
                        $helpers
                          .requiredlabel(
                            requirement,
                            'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                          )
                          .slice(0, 1) == '*'
                          ? 'text-danger'
                          : ''
                      "
                      label-size="sm"
                      label-cols="12"
                    >
                      <!-- label="Your Ref / PO (incl. Requistion No's e.g. A,B,C)"
                    label-for="yourref" -->
                      <b-form-textarea
                        id="data"
                        v-model="item.yourref"
                        placeholder="Your Ref"
                        rows="2"
                        class="smalltextarea"
                        trim
                      ></b-form-textarea>
                    </b-form-group> </b-col
                ></b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group
                      label="Description (Leave empty for Event Name)"
                      label-for="description"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.description"
                          placeholder="Description"
                          size="sm"
                          trim
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.description = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Event" label-size="sm">
                      <treeselect
                        placeholder="Select event..."
                        searchPromptText="Type at least 4 chars..."
                        v-model="item.eventcode"
                        :clearable="true"
                        :async="true"
                        :load-options="treeselect_loadEvent"
                        :show-count="true"
                        :flatten-search-results="true"
                        :disable-branch-nodes="true"
                        :matchKeys="['id']"
                        search-nested
                        :multiple="true"
                      >
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label-cols="12"
                      :label="
                        $helpers.requiredlabel(requirement, 'Client SL A/C')
                      "
                      :class="
                        $helpers
                          .requiredlabel(requirement, 'Client SL A/C')
                          .slice(0, 1) == '*'
                          ? 'text-danger'
                          : ''
                      "
                      label-size="sm"
                    >
                      <treeselect
                        placeholder="Select slac..."
                        searchPromptText="Type at least 3 chars..."
                        v-model="item.slac"
                        :clearable="true"
                        :async="true"
                        :load-options="treeselect_loadSLAC"
                        :show-count="true"
                        :flatten-search-results="true"
                        :disable-branch-nodes="true"
                        :matchKeys="['id']"
                        search-nested
                        :disabled="readonly"
                        :multiple="true"
                      >
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Total (Ex VAT)"
                      label-for="valueexvat"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.valueexvat"
                          placeholder="Total (Ex VAT)"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.valueexvat = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="VAT"
                      label-for="valuevat"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.valuevat"
                          placeholder="VAT"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.valuevat = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Total"
                      label-for="total"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.value"
                          placeholder="Total"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.value = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Placed"
                      label-for="placed"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.dateplaced"
                            button-only
                            label-help=""
                            locale="en-GB"
                            hide-header
                            :disabled="readonly"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.dateplaced"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="readonly"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            :disabled="readonly"
                            @click="item.dateplaced = null"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Contact"
                      label-for="contact"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.contact"
                          placeholder="Contact"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.contact = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Contract"
                      label-for="contract"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.contract"
                          placeholder="Contract"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.contract = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Reason ?"
                      label-for="reason"
                      label-cols="12"
                      label-size="sm"
                    >
                      <treeselect
                        v-model="item.reason"
                        :clearable="true"
                        :options="reasoncode_options"
                      ></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Date Required"
                      label-for="daterequired"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.daterequired"
                            button-only
                            label-help=""
                            locale="en-GB"
                            hide-header
                            :disabled="readonly"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.daterequired"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="readonly"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            :disabled="readonly"
                            @click="item.daterequired = null"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Date Expiry"
                      label-for="dateexpiry"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.dateexpiry"
                            button-only
                            label-help=""
                            locale="en-GB"
                            hide-header
                            :disabled="readonly"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.dateexpiry"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="readonly"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            :disabled="readonly"
                            @click="item.dateexpiry = null"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label-cols="12"
                      label="Status"
                      label-size="sm"
                    >
                      <treeselect
                        placeholder="Select status..."
                        v-model="item.status"
                        :clearable="true"
                        :options="status_options"
                        :show-count="true"
                        :flatten-search-results="true"
                        :disable-branch-nodes="true"
                        :matchKeys="['id']"
                        search-nested
                      >
                      </treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>

            <b-tab>
              <template #title>
                <i class="fa fa-sitemap text-primary mr-1"></i> Roomlist
              </template>
              <!-- <b-alert
                :show="hotelsroomlists_incomplete"
                variant="danger"
                class="mt-2"
              >
                <b-row align-v="center" no-gutters
                  ><b-col cols="auto mr-3">
                    <i class="fa fa-info-circle fa-2x"></i
                  ></b-col>
                  <b-col
                    >One or more of the outlook forecasts has a zero value. This
                    can be normal whilst the event is in the planning stage or has been completely invoiced.
                    Please return frequently for updates.</b-col
                  ></b-row
                >
              </b-alert> -->
              <e-table
                v-if="!component"
                class="etable"
                :refid="'etable'"
                :busy="busy"
                :fields="table_e.fields"
                :items="item.hotelsroomlists"
                :tools_enabled="'paste,notes,refresh,export,delete'"
                :showpages="false"
                @toolClick="hotelsroomlists_toolClick"
                @change="hotelsroomlists_update"
                @select="hotelsroomlists_select"
              />
              <!-- {{ hotelsroomlists }} -->
              <div v-if="component">
                <component
                  :is="component"
                  :selection="hotelsroomlists_selection"
                  :config="cconfig"
                  @saveit="saveit"
                  @discard="toolClick('discard')"
                  @refresh="toolClick('refresh')"
                ></component>
              </div>
            </b-tab>

            <b-tab v-if="this.user.permissions.includes('hotels.accounting')">
              <template #title>
                <i class="fa fa-gbp text-primary mr-1"></i> Accounting
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Manager"
                      label-for="manager"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.manager"
                          placeholder="Manager"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.manager = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label-cols="12"
                      label="Margin By"
                      label-size="sm"
                    >
                      <treeselect
                        placeholder="Select margin by..."
                        v-model="item.marginby"
                        :clearable="true"
                        :options="marginby_options"
                        :show-count="true"
                        :flatten-search-results="true"
                        :disable-branch-nodes="true"
                        :matchKeys="['id']"
                        search-nested
                      >
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Margin Value"
                      label-for="margin"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.margin"
                          placeholder="Margin"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.margin = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group
                      label="Click x to remove or browse for document upload..."
                      label-size="sm"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-button
                            size="sm"
                            title="delete"
                            variant="outline-danger"
                            @click="fileUpload_clear"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-prepend>
                        <b-form-file
                          class="ml-1 z-0"
                          id="file-small"
                          size="sm"
                          ref="file-input"
                          :multiple="false"
                          no-drop
                          @change="fileUpload_selected"
                          :placeholder="
                            fileUpload ? fileUpload.name : 'No file chosen'
                          "
                          :disabled="fileUpload ? true : false"
                        ></b-form-file>
                        <b-input-group-append>
                          <b-button
                            class="ml-1"
                            size="sm"
                            title="view file"
                            variant="outline-primary"
                            @click="fileUpload_view"
                            :disabled="!fileUpload"
                          >
                            <i class="fa fa-download"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>

            <b-tab>
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row v-if="idselected">
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Created At"
                      label-for="created_at"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.created_at"
                            button-only
                            label-help=""
                            locale="en-GB"
                            :disabled="true"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.created_at"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.created_at = null"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Created By"
                      label-for="created_by"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.created_by"
                          placeholder=""
                          size="sm"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.created_by = ''"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Updated At"
                      label-for="updated_at"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.updated_at"
                            button-only
                            label-help=""
                            locale="en-GB"
                            :disabled="true"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.updated_at"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.updated_at = null"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Updated By"
                      label-for="updated_by"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.updated_by"
                          placeholder=""
                          size="sm"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.updated_by = ''"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
          </b-tabs>
        </b-card-body>

        <b-card-footer class="mt-2 ml-1">
          <b-row>
            <b-col class="text-left">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="3">
              <b-button
                squared
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
              <b-button
                squared
                size="sm"
                variant="primary"
                @click="saveit()"
                v-if="
                  !item.invoiceno
                    ? true
                    : false || user.permissions.includes('hotels.save')
                "
              >
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

import HotelRoomlistsNotes from "./HotelRoomlistsNotes";

export default {
  name: "HotelRoomlistsEdit",
  components: {
    HotelRoomlistsNotes,
  },
  mounted() {
    this.item.agent = this.user.initials;
  },
  data() {
    return {
      busy: false,
      readonly: false,
      requirement: {
        slac: "Client SL A/C",
        yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
      },
      item: {
        id: null,
        slac: [],
        eventcode: [],
        dateplaced: this.$moment().format("YYYY-MM-DD"),
        notes: null,
        status: "1",
        agent: null,
      },
      items: [],
      payby_options: [{ id: "IN", label: "Invoice" }],
      marginby_options: [
        { id: "COM", label: "Commission" },
        { id: "FEE", label: "Fee" },
      ],
      status_options: [
        { id: "0", label: "Cancelled" },
        { id: "1", label: "Active" },
        { id: "2", label: "Pending" },
      ],
      reasoncode_options: [],

      options: {
        title: "Hotel Roomlist Edit",
        icon_header: "fa fa-list",
        icon: "fa fa-list",
        debounce: 500,
      },
      component: null,
      hotelsroomlists_incomplete: false,
      hotelsroomlists_selection: [],
      hotelsroomlists: [],
      table_e: {
        fields: [
          {
            key: "destination",
            label: "Destination",
            type: "text",
            placeholder: "Destination (AAA) or * for all",
            class: "text-right w-10pct",
            clearable: "true",
          },
          {
            key: "hotelname",
            label: "Hotel Name",
            type: "text",
            placeholder: "Hotel Name",
            class: "text-right w-20pct",
            clearable: "true",
          },
          {
            key: "lastname",
            label: "Last Name",
            type: "text",
            placeholder: "Last Name",
            class: "text-right w-20pct",
            clearable: "true",
          },
          {
            key: "rooms",
            label: "Rooms",
            type: "text",
            placeholder: "Rooms",
            class: "text-right w-10pct",
            clearable: "true",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-20pct",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "nights",
            label: "Nights",
            type: "text",
            placeholder: "Nights",
            class: "text-right w-10pct",
            disabled: "true",
          },

          // WE DONT NEED THIS FOR NOW
          // {
          //   key: "value",
          //   label: "Value",
          //   type: "text",
          //   class: "text-right w-10pct",
          //   disabled: "true",
          // },
        ],
      },
    };
  },
  watch: {
    fileUpload: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          console.log("watch:fileUpload", newVal);
        }
      },
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        // slac: this.slac.length > 0 ? this.slac.join(",") : null,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_old($id: String, $dateformat: String) {
              hotels_old(id: $id, dateformat: $dateformat) {
                id
                description
                yourref
                dateplaced
                status
                agent
                eventcode
                slac
                notes
                # valueexvat
                # valuevat
                # value
                # reason
                # contact
                # contract
                # daterequired
                # dateexpiry
                manager
                marginby
                margin
                # to
                data
                created_at
                created_by
                updated_at
                updated_by
                hotelsroomlists_old {
                  id
                  line
                  destination
                  hotelname
                  lastname
                  rooms
                  nights
                  datetravel
                  # value
                }
                # SLTransactions {
                #   id
                #   ref
                # }
              }
            }
          `,
          variables,
        });

        if (response.data.hotels_old.length > 0) {
          this.item = response.data.hotels_old[0];

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
          this.item.eventcode = this.item.eventcode
            ? this.item.eventcode.split(",")
            : [];

          if (this.item.data) {
            try {
              this.fileUpload = JSON.parse(this.item.data);
            } catch (error) {
              this.fileUpload = {
                name: this.item.yourref + ".pdf",
                data: this.item.data,
              };
            }
          }

          this.hotelsroomlists_incomplete = false;
          for (var j = 0; j < this.item.hotelsroomlists_old.length; ++j) {
            if (this.item.hotelsroomlists_old[j].value == 0) {
              this.hotelsroomlists_incomplete = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_ordersreasons {
              setup_ordersreasons {
                id
                label
                type
              }
            }
          `,
        });
        this.reasoncode_options = response.data.setup_ordersreasons;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let row = this.cleanit(this.item);

      this.message = this.$helpers.mandatoryFields(
        {
          slac: "Client SL A/C",
          yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
        },
        row
      );
      if (this.message.length > 0) {
        return;
      }

      this.busy = true;

      this.item.slac =
        this.item.slac.length > 0 ? this.item.slac.join(",") : null;
      this.item.eventcode =
        this.item.eventcode.length > 0 ? this.item.eventcode.join(",") : null;

      let variables = { rows: [this.cleanit(this.item)] };
      // delete variables.rows[0].SLTransactions;

      if (this.fileUpload) {
        variables.rows[0].data = JSON.stringify(this.fileUpload);
      } else {
        variables.rows[0].data = "";
      }
      // PUT ANY NEW ROOMLISTS TO SAVE OBJECT
      if (this.hotelsroomlists_old.length > 0) {
        variables.rows[0].hotelsroomlists_old = this.hotelsroomlists_old;
      }

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation hotels_save_old($rows: [Hotel_old_input], $dateformat: String) {
              hotels_save_old(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;

      this.load();
      return;
    },
    hotelsroomlists_toolClick(e, a) {
      console.log("hotelsroomlists_toolClick", e, a);
      switch (a) {
        case "refresh":
          this.load();
          break;
        case "notes":
          this.component = "HotelRoomlistsNotes";
          break;
        case "deleteit":
          this.hotelsroomlists_delete(e);
          break;
      }
    },
    hotelsroomlists_update(e) {
      console.log("hotelsroomlists_update", e);
      this.hotelsroomlists = e;
    },
    hotelsroomlists_select(e) {
      console.log("hotelsroomlists_select", e);
      this.hotelsroomlists_selection = e;
    },
    async hotelsroomlists_delete(e) {
      console.log("hotelsroomlists_delete", e);
      // PASS THE ID LIST TO DELETE MUTATION

      let variables = {
        rows: this.cleanit(e),
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation hotelsroomlists_delete_old($rows: [HotelRoomlist_old_input]) {
              hotelsroomlists_delete_old(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },
  },
};
</script>

<style>
.card {
  text-align: left !important;
}
</style>